import { Injectable } from '@angular/core';

import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { cloneDeep } from 'lodash-es';

import { getNavigation } from '@hmax-order/shared/navigation';
import { compactNavigation, futuristicNavigation, horizontalNavigation } from './data';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
  private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
  private readonly _defaultNavigation: FuseNavigationItem[] = getNavigation('company');
  private readonly _organizationNavigation: FuseNavigationItem[] = getNavigation('organization');
  private readonly _superNavigation: FuseNavigationItem[] = getNavigation('super');
  private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
  private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;
  private readonly _demoViewerNavigation: FuseNavigationItem[] = getNavigation('demo-viewer');

  /**
   * Constructor
   */
  constructor(private _fuseMockApiService: FuseMockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    const navigation = this._defaultNavigation;

    // -----------------------------------------------------------------------------------------------------
    // @ Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService.onGet('api/common/navigation').reply(() => {
      // Fill compact navigation children using the default navigation
      // this._compactNavigation.forEach((compactNavItem) => {
      //   this._defaultNavigation.forEach((defaultNavItem) => {
      //     if (defaultNavItem.id === compactNavItem.id) {
      //       compactNavItem.children = cloneDeep(defaultNavItem.children);
      //     }
      //   });
      // });

      // Fill futuristic navigation children using the default navigation
      // this._futuristicNavigation.forEach((futuristicNavItem) => {
      //   this._defaultNavigation.forEach((defaultNavItem) => {
      //     if (defaultNavItem.id === futuristicNavItem.id) {
      //       futuristicNavItem.children = cloneDeep(defaultNavItem.children);
      //     }
      //   });
      // });

      // // Fill horizontal navigation children using the default navigation
      // this._horizontalNavigation.forEach((horizontalNavItem) => {
      //   this._defaultNavigation.forEach((defaultNavItem) => {
      //     if (defaultNavItem.id === horizontalNavItem.id) {
      //       horizontalNavItem.children = cloneDeep(defaultNavItem.children);
      //     }
      //   });
      // });

      // Return the response
      return [
        200,
        {
          // compact: cloneDeep(this._compactNavigation),
          default: cloneDeep(navigation),
          // futuristic: cloneDeep(this._futuristicNavigation),
          // horizontal: cloneDeep(this._horizontalNavigation),
        },
      ];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Organization Navigation  - GET
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService.onGet('api/common/organization-navigation').reply(() => {
      // Return the response
      return [200, { default: cloneDeep(this._organizationNavigation) }];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Super User Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService.onGet('api/common/super-navigation').reply(() => {
      // Return the response
      return [
        200,
        {
          default: cloneDeep(this._superNavigation),
        },
      ];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Demo Viewer Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService.onGet('api/common/demo-viewer-navigation').reply(() => {
      // Return the response
      return [
        200,
        {
          default: cloneDeep(this._demoViewerNavigation),
        },
      ];
    });
  }
}
